export const medicalReportTypes = [
    'Computed Tomography (CT)',
    'X-Ray',
    'Magnetic Resonance Imaging (MRI)',
    'Positron Emission Tomography (PET)',
    'Ultrasound (US)',
    'Disease Photos'
];
